<!-- <div class="container">
  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Active Vessels">
      <ng-container *ngIf="selectedTab === true">
        <app-port-active-vessels></app-port-active-vessels>
      </ng-container>
    </mat-tab>
    <mat-tab label="Inactive vessels"
      >
      <ng-container *ngIf="selectedTab === false">
        <app-port-inactive-vessels #inActive></app-port-inactive-vessels>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</div> -->


 <app-port-active-vessels></app-port-active-vessels>